import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { LocaleContext } from 'containers/LocaleContext';
import { useStore } from 'hooks/useStore';
const allowedLocales = ['de', 'en', 'nl', 'fr'];
const allowedCountryCodes = ['DEU', 'CHE', 'GBR', 'NLD', 'BEL', 'FRA', 'CHE'];
export function LastRouter() {
    const navigate = useNavigate();
    const params = useParams();
    const store = useStore();
    const { changeLocale } = useContext(LocaleContext);
    useEffect(() => {
        const timeout = setTimeout(() => {
            var _a, _b;
            const locale = (_a = params === null || params === void 0 ? void 0 : params.localeWithCountryCode) === null || _a === void 0 ? void 0 : _a.substring(0, 2);
            const countryCode = (_b = params === null || params === void 0 ? void 0 : params.localeWithCountryCode) === null || _b === void 0 ? void 0 : _b.substring(3, 6);
            if (locale &&
                countryCode &&
                allowedLocales.includes(locale) &&
                allowedCountryCodes.includes(countryCode)) {
                changeLocale(locale);
                store.setStore({
                    country: countryCode,
                });
                navigate('/');
            }
            else {
                navigate('/page-not-found');
            }
        }, 0);
        return () => {
            clearTimeout(timeout);
        };
    }, [changeLocale, params, navigate, store]);
    return null;
}
